import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Link from "next/link";

interface DynamicLinkButtonProps {
  value: string;
  href: string;
  variant?: "default" | "secondary" | "dark_blue" | "outline" | "white"; // Added outline variant
  className?: string;
}

export function DynamicLinkButton({
  value,
  href,
  variant = "default",
  className = "",
}: DynamicLinkButtonProps) {
  // Define custom variants' class styles
  const variantClasses: Record<typeof variant, string> = {
    default: "cursor-pointer shadow-none rounded-full md:h-12 md:w-40.75",
    secondary: "cursor-pointer shadow-none rounded-full md:h-12 md:px-6.25",
    white: "cursor-pointer shadow-none bg-white border rounded-full md:h-12 md:px-6.25",
    dark_blue: "shadow-none bg-custom-blue rounded-full md:h-12 md:px-7 hover:bg-[#000929]/80",
    outline: "cursor-pointer shadow-none rounded-full md:h-12 md:px-6.25 border border-[#151A28] bg-transparent hover:bg-gray-100/10",
  };

  const textClasses: Record<typeof variant, string> = {
    default: "text-md sm:text-md md:text-lg lg:text-lg font-medium leading-[1.1]",
    secondary: "text-md sm:text-md md:text-lg lg:text-lg font-medium text-[#151A28] leading-[1.1]",
    white: "text-md sm:text-md md:text-lg lg:text-lg font-medium text-[#151A28]",
    dark_blue: "text-md sm:text-md md:text-lg text-white font-medium leading-[1.1]",
    outline: "text-md sm:text-md md:text-lg lg:text-lg font-medium text-[#151A28] leading-[1.1]",
  };

  return (
    <Link href={href} target="_blank">
      <Button
        variant={variant === "outline" ? "outline" : variant === "default" ? "default" : "secondary"}
        className={cn(variantClasses[variant], className)}
      >
        <p className={textClasses[variant]}>{value}</p>
      </Button>
    </Link>
  );
}
